<ion-item [formGroup]="parent">
  <ion-checkbox
    [id]="question.key"
    [color]="question.color"
    [formControlName]="question.key"
    [attr.disabled]="question.disabled || question.readonly"
  >
  </ion-checkbox>
</ion-item>
